<template>
  <div id="contenedor-opciones-tool-bar">
    <v-tabs>
      <v-tab
        v-for="(opcion, index) in opciones"
        :key="index"
        :to="{ name: opcion.ruta }"
        exact>
        {{ opcion.nombre }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'OpcionesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Estatus contratos',
          ruta: 'consultasEstatusContratos',
          icono: '',
        },
        /*
        {
          nombre: 'Informe ejecutivo',
          ruta: 'consultasInformeEjecutivo',
          icono: '',
        }, */
        // {
        //   nombre: 'Estadisticas',
        //   ruta: 'consultasEstadisticas',
        //   icono: '',
        // },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
